<template>
  <v-card class="pa-4">
    <p class="home-section-title">Webinars</p>
    <v-container
      v-for="(webinar, index) in webinars"
      :key="index"
    >
      <a :href="webinar.href" target="_blank" class="unlink">
        <v-layout row wrap>
          <v-flex xs12 sm3>
            <v-img
              :src="webinar.image"
              class="webinarimg"
            ></v-img>
          </v-flex>
          <v-flex xs12 sm9 class="pl-4">
            <div class="title mb-3">{{webinar.title}}</div>
            <div class="my-2"><v-icon class="mr-2">date_range</v-icon>{{webinar.date}}</div>
          </v-flex>
        </v-layout>
      </a>
    </v-container>
  </v-card>
</template>

<script>
import ImgStaphB2022 from "@bugseq-site/www/src/assets/img/resources/webinars/2022-staphb.png"
import ImgGenomicProfiling2024 from "@bugseq-site/www/src/assets/img/resources/webinars/2024-genomic-profiling.webp"
import ImgONTBugSeq2024 from "@bugseq-site/www/src/assets/img/resources/webinars/2024-ont-bugseq.webp";
import ImgIDAMROutbreak2025 from "@bugseq-site/www/src/assets/img/resources/webinars/2025-id-amr-outbreak.png";
import ImgGlobalLessons2026 from "@bugseq-site/www/src/assets/img/resources/webinars/2026-global-lessons.webp";

export default {
  metaInfo: {
    title: "Webinars",
    titleTemplate: "BugSeq | %s",
  },
  data() {
    return {
      webinars: [
        {
          title: "Global lessons from metagenomics for future critical care and pathogen surveillance",
          date: "January 14, 2026",
          image: ImgGlobalLessons2026,
          href: "https://nanoporetech.com/about/events/webinars/global-lessons-from-metagenomics-in-critical-care-and-pathogen-surveillance",
        },
        {
          title: "Leveraging Advanced Bioinformatics for Organism Identification, AMR, and Outbreak Surveillance",
          date: "September 29, 2025",
          image: ImgIDAMROutbreak2025,
          href: "https://event.on24.com/wcc/r/5066485/FFB4EB657C58A573A04995B2E0099F45",
        },
        {
          title: "Advances in genomic profiling of respiratory viral pathogens",
          date: "November 14, 2024",
          image: ImgGenomicProfiling2024,
          href: "https://nanoporetech.com/resource-centre/advances-in-genomic-profiling-of-respiratory-viral-pathogens",
        },
        {
          title: "Real-time infectious disease outbreak investigations with nanopore sequencing and BugSeq analysis",
          date: "April 11, 2024",
          image: ImgONTBugSeq2024,
          href: "https://nanoporetech.com/resource-centre/real-time-infectious-disease-outbreak-investigations-with-nanopore-sequencing-and-bugseq-analysis",
        },
        {
          title: "StaPH-B Monthly Webinar: An automated, scalable DNA sequencing analysis platform for clinical and public health labs",
          date: "June 30, 2022",
          image: ImgStaphB2022,
          href: "https://www.youtube.com/watch?v=jzo1icXrX4A",
        },
      ],
    }
  },
};
</script>

<style scoped>
.webinarimg {
  border-radius: 5px;
}

.unlink {
  color: black;
  text-decoration: none;
}
</style>
